const ICON_SIZE = 20 as const;

export { ICON_SIZE };
